module.exports = __webpack_public_path__ + "img/bus-green.f941869d.svg";